import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import MinicrudSelect from '../../../../containers/minicruds/select/MinicrudSelect'
import PlaceSelect from '../../../../containers/places/select/PlaceSelect'
import Select from '../../../../packages/kiti/components/form/Select'
import { usePlaceTypesWithPermission } from '../../../../utils/helpers/placeTypes'

const GeneralSection = () => {
  const { t } = useTranslation('editAsset')
  const form = useForm()
  const { handleChange } = useFormState()
  const placeTypes = usePlaceTypesWithPermission('list')

  const handleAfterChangePlaceType = () => {
    handleChange('place', undefined)
  }

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('name')} field="name" />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem
          label={t('placeType')}
          field="placeType"
          Input={Select}
          afterChange={handleAfterChangePlaceType}
          options={placeTypes.map(type => ({ id: type.id, value: type.key, name: type.namePlural }))}
        />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem label={t('place')} field="place" Input={PlaceSelect} type={form?.placeType?.value} />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem label={t('type')} field="type" Input={MinicrudSelect} entity="assetType" />
      </Col>
    </Grid>
  )
}

export default GeneralSection
